import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IOrganization } from 'hooks/useGetUserOrganizations';

export const getDealOrganization = async (dealId: number): Promise<IOrganization> => {
    const response = await axiosInstance.get<IOrganization>(API_ENDPOINTS.DEAL_ORGANIZATION(dealId));
    return response.data;
};

type DealOrgQueryKey = readonly ['dealOrganization', number];

type UseGetDealOrganizationOptions = Omit<UseQueryOptions<IOrganization, Error, IOrganization, DealOrgQueryKey>, 'queryKey' | 'queryFn'>;

interface UseGetDealOrganizationProps {
  dealId: number;
  options?: UseGetDealOrganizationOptions;
}

const useGetDealOrganization = ({
    dealId,
    options = {},
}: UseGetDealOrganizationProps): UseQueryResult<IOrganization, Error> => {
    const {
        enabled = true,
        staleTime = Infinity,
        ...restOptions
    } = options;

    return useQuery<IOrganization, Error, IOrganization, DealOrgQueryKey>({
        queryKey: ['dealOrganization', dealId] as const,
        queryFn: () => getDealOrganization(dealId),
        enabled: enabled && !!dealId,
        staleTime,
        ...restOptions,
    });
};

export default useGetDealOrganization;
